import {
    BackspaceOutlined as BackspaceOutlinedIcon,
    DeleteForeverOutlined as DeleteForeverOutlinedIcon, // momentâneo
    EditTwoTone as EditTwoToneIcon,
    VisibilityOutlined as VisibilityOutlinedIcon
} from '@material-ui/icons';
import {
    Button, Card, CardContent, Input, MenuItem, Paper, Select, Table, TableBody, TableCell, TableHead,
    TablePagination, TableRow, Tooltip
} from '@material-ui/core';
import { ANAO, ASIM } from 'consts';
import { Link } from 'react-router-dom';
import api from '../../../services/api';
import React, { Component } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import DeleteConfirmationModal from '../../../components/DeleteConfirmationModal/DeleteConfirmationModal';

class UsuarioPartnerList extends Component {
    state = {
        searchFilter: JSON.parse(sessionStorage.getItem('usuariopartnerSearchFilter')) || {
            nomeusuario: '',
            inativousuario: ANAO
        },
        usuarios: [],
        totalItems: 0,
        page: Number(sessionStorage.getItem('usuariopartnerPage')) || 0,
        rowsPerPage: Number(sessionStorage.getItem('usuariopartnerRowsPerPage')) || 10,
        selectedId: null,
        selectedNomeUsuario: '',
        open: false
    };
    estilo = {
        marginLeft: 30,
        marginTop: 30,
        marginRight: 30,
        addButton: {
            height: '42px',
            display: 'flex',
            alignItems: 'center',
            float: 'right',
            marginTop: 3,
            marginRight: 3
        },
        redText: {
            color: 'red'
        }
    };

    constructor(props) {
        super(props);
    };

    /* Carregamento inicial */
    async componentDidMount() {
        this.loadUsuarios();
    };

    /* Paginação */
    componentDidUpdate(prevState) {
        const { searchFilter, page, rowsPerPage } = this.state;

        // persiste filtros e paginação no sessionStorage
        if (prevState.searchFilter !== searchFilter) {
            sessionStorage.setItem('usuariopartnerSearchFilter', JSON.stringify(searchFilter));
        }
        if (prevState.page !== page) {
            sessionStorage.setItem('usuariopartnerPage', page);
        }
        if (prevState.rowsPerPage !== rowsPerPage) {
            sessionStorage.setItem('usuariopartnerRowsPerPage', rowsPerPage);
        }
    };

    /* Carrega usuários */
    loadUsuarios = async () => {
        const { page, rowsPerPage, searchFilter } = this.state;
        const { nomeusuario, inativousuario } = searchFilter;

        let params = `?page=${page + 1}&limit=${rowsPerPage}`;

        if (nomeusuario) {
            params += `&NOMEUSUARIO=_like_${nomeusuario}`;
        }

        if (inativousuario === ASIM || inativousuario === ANAO) {
            params += `&INATIVOUSUARIO=${inativousuario}`;
        }

        try {
            const response = await api.get('/usuariopartner' + params);
            this.setState({
                usuarios: response.data.data || [],
                totalItems: parseInt(response.data.info && response.data.info.totalrecords, 10) || 0
            });
        } catch (error) {
            console.error('Erro ao carregar usuários partner:', error);
            this.setState({ usuarios: [], totalItems: 0 });
        }
    };

    /* Muda página */
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, () => this.loadUsuarios());
    };

    /* Muda quantidade por página */
    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 }, () => this.loadUsuarios());
    };

    /* Escolha de um registro para exclusão */
    handleSelectItem = (id, nomeusuario) => {
        this.setState({ selectedId: id, selectedNomeUsuario: nomeusuario });
    };

    /* Deleta usuário */
    handleDelete = async (id) => {
        try {
            const response = await api.delete(`/usuariopartner/${id}`);
            // verifica se a exclusão foi bem-sucedida
            if (response.status === 200) {
                this.handleClose();
                this.loadUsuarios();
            }
        } catch (error) {
            this.handleClose();
            this.handleOpenAlert(error.response.data.error);
        }
    };

    /* Abre janela confirmação para exclusão */
    handleOpen = (id, nomeusuario) => {
        this.setState({ open: true });
        this.handleSelectItem(id, nomeusuario);
    };

    /* Abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true });
        this.setState({ messageAlert: message });
    };

    /* Fecha janela de confirmação exclusão */
    handleClose = () => {
        this.setState({ open: false });
    };

    /* Fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Pesquisar filtros na tela */
    onChangeSearch = (event) => {
        const { name, value } = event.target;
        const searchFilter = { ...this.state.searchFilter, [name]: value.toUpperCase() };

        this.setState({ searchFilter }, () => {
            if (name === 'nomeusuario') {
                // debounce para buscar
                clearTimeout(this.searchDebounce);
                this.searchDebounce = setTimeout(() => {
                    this.loadUsuarios();
                }, 300);
            }
            if (name === 'inativousuario') {
                // se mudar filtro de inativação, busca imediatamente
                this.loadUsuarios();
            }
        });
    };

    /* Limpa Filtros na tela */
    limpaFiltros = () => {
        const searchFilter = {
            nomeusuario: '',
            inativousuario: ANAO
        };

        this.setState({ searchFilter }, () => {
            this.loadUsuarios();
        });
    };

    render() {
        const {
            usuarios,
            searchFilter,
            open,
            selectedId,
            selectedNomeUsuario,
            openAlert,
            messageAlert,
            totalItems,
            page,
            rowsPerPage
        } = this.state;

        return (
            <div style={this.estilo}>
                <Paper
                    hover
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'nowrap',
                        padding: '6px 4px',
                        width: '100%'
                    }}
                >
                    <Input
                        autoFocus
                        id="nomeusuario"
                        name="nomeusuario"
                        onBlur={this.onInputBlur}
                        onChange={this.onChangeSearch}
                        placeholder="Usuário"
                        value={searchFilter.nomeusuario}
                        style={{
                            marginBottom: 10,
                            width: 100,
                            marginLeft: 10,
                            marginTop: 10
                        }}
                    />

                    <Select
                        id="inativousuario"
                        name="inativousuario"
                        value={searchFilter.inativousuario || ''}
                        onChange={this.onChangeSearch}
                        style={{
                            marginBottom: 10,
                            width: 100,
                            marginLeft: 15,
                            marginTop: 10,
                            textAlign: 'center'
                        }}
                    >
                        <MenuItem
                            value={ANAO}
                            style={{ justifyContent: 'center' }}
                        >
                            Ativos
                        </MenuItem>

                        <MenuItem
                            value={ASIM}
                            style={{ justifyContent: 'center' }}
                        >
                            Inativos
                        </MenuItem>

                        <MenuItem
                            value={'T'}
                            style={{ justifyContent: 'center' }}
                        >
                            Todos
                        </MenuItem>
                    </Select>

                    <Tooltip
                        title="Limpar"
                        enterDelay={50}
                    >
                        <BackspaceOutlinedIcon
                            onClick={() => this.limpaFiltros()}
                            onMouseEnter={(e) => e.currentTarget.style.color = '#1976d2'}
                            onMouseLeave={(e) => e.currentTarget.style.color = '#0000ee'}
                            style={{
                                fontSize: 24,
                                color: '#0000ee',
                                cursor: 'pointer',
                                marginLeft: 6
                            }}
                        />
                    </Tooltip>

                    <div style={{ flex: 1 }} />

                    <Button
                        component={Link}
                        to="/admpartner/usuariopartner/novo"
                        variant="contained"
                        color="primary"
                        style={this.estilo.addButton}
                    >
                        Novo
                    </Button>
                </Paper>

                <br />

                <Card>
                    <CardContent>
                        <PerfectScrollbar>
                            <div>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Código</TableCell>

                                            <TableCell align="center">Usuário</TableCell>

                                            <TableCell align="center">Ações</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {usuarios.map(usuariopartner => (
                                            <TableRow
                                                hover
                                                key={usuariopartner.id}
                                            >
                                                <TableCell
                                                    align="center"
                                                    style={(usuariopartner.inativousuario === ASIM) ? this.estilo.redText : {}}
                                                >
                                                    {usuariopartner.id}
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    style={(usuariopartner.inativousuario === ASIM) ? this.estilo.redText : {}}
                                                >
                                                    {usuariopartner.nomeusuario}
                                                </TableCell>

                                                <TableCell align="center">
                                                    <Tooltip
                                                        title="Editar"
                                                        enterDelay={50}
                                                    >
                                                        <Link to={`/admpartner/usuariopartner/${usuariopartner.id}`}>
                                                            <EditTwoToneIcon
                                                                onMouseEnter={(e) => e.currentTarget.style.color = '#1976d2'}
                                                                onMouseLeave={(e) => e.currentTarget.style.color = '#0000ee'}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    color: '#0000ee',
                                                                    marginRight: 6
                                                                }}
                                                            />
                                                        </Link>
                                                    </Tooltip>

                                                    <Tooltip
                                                        title="Visualizar"
                                                        enterDelay={50}
                                                    >
                                                        <Link to={`/admpartner/usuariopartner/${usuariopartner.id}/view`}>
                                                            <VisibilityOutlinedIcon
                                                                onMouseEnter={(e) => e.currentTarget.style.color = '#1976d2'}
                                                                onMouseLeave={(e) => e.currentTarget.style.color = '#0000ee'}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    color: '#0000ee',
                                                                    marginRight: 6
                                                                }}
                                                            />
                                                        </Link>
                                                    </Tooltip>

                                                    <Tooltip
                                                        title="Excluir"
                                                        enterDelay={50}
                                                    >
                                                        <DeleteForeverOutlinedIcon
                                                            onMouseEnter={(e) => e.currentTarget.style.color = 'red'}
                                                            onMouseLeave={(e) => e.currentTarget.style.color = ''}
                                                            onClick={() => this.handleOpen(usuariopartner.id, usuariopartner.nomeusuario)}
                                                            style={{
                                                                cursor: 'pointer'
                                                            }}
                                                        />
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </PerfectScrollbar>
                    </CardContent>
                </Card>

                <TablePagination
                    component="div"
                    count={totalItems}
                    page={page}
                    onPageChange={this.handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                    rowsPerPageOptions={[10, 50, 100, 150]}
                    labelRowsPerPage="Registros por página"
                />

                <DeleteConfirmationModal
                    open={open}
                    handleClose={() => this.handleClose()}
                    itemId={selectedId}
                    message={"Confirma exclusão do usuário " + selectedNomeUsuario + '?'}
                    handleDelete={() => this.handleDelete(selectedId)}
                />

                <AlertInformation
                    open={openAlert}
                    handleClose={() => this.handleCloseAlert()}
                    message={messageAlert}
                />
            </div>
        );
    }
}

export default UsuarioPartnerList;